/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SDKEventPersonIdentifiedV1AllOf
 */
export interface SDKEventPersonIdentifiedV1AllOf {
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventPersonIdentifiedV1AllOf
     */
    person_id: string;
}

/**
 * Check if a given object implements the SDKEventPersonIdentifiedV1AllOf interface.
 */
export function instanceOfSDKEventPersonIdentifiedV1AllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "person_id" in value;

    return isInstance;
}

export function SDKEventPersonIdentifiedV1AllOfFromJSON(json: any): SDKEventPersonIdentifiedV1AllOf {
    return SDKEventPersonIdentifiedV1AllOfFromJSONTyped(json, false);
}

export function SDKEventPersonIdentifiedV1AllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventPersonIdentifiedV1AllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'person_id': json['person_id'],
    };
}

export function SDKEventPersonIdentifiedV1AllOfToJSON(value?: SDKEventPersonIdentifiedV1AllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_id': value.person_id,
    };
}

